// STEP 5-CT-B · 소비자 문의 카테고리 통일 (Frontend only · Backend canonical 8종 무변경)
// - 소비자 UI 는 5개 그룹 label 만 노출
// - 저장 시 각 그룹의 canonical 대표값 1개로 저장
// - 기존 데이터 (canonical 8종) 는 그대로 유지되며 표시 계층에서만 5개 label 로 그룹핑

// 소비자에게 노출되는 5개 그룹 (표시 순서 = UI 순서)
export const CONSUMER_GROUPS = [
  { key: 'product',  label: '상품 문의',            canonicals: ['product'] },
  { key: 'order',    label: '주문·결제 문의',       canonicals: ['order', 'payment'] },
  { key: 'shipping', label: '배송 문의',            canonicals: ['shipping'] },
  { key: 'rma',      label: '취소·교환·반품 문의',  canonicals: ['return', 'exchange', 'cancel'] },
  { key: 'other',    label: '기타 문의',            canonicals: ['other'] },
];

// 그룹 → 저장할 canonical 대표값 (5→8 매핑)
export const GROUP_TO_CANONICAL = {
  product: 'product',
  order: 'order',
  shipping: 'shipping',
  rma: 'return',
  other: 'other',
};

// canonical 8종 → 5개 그룹 key (역매핑 · Reverse) — 기존 데이터 label 표시용
export const CANONICAL_TO_GROUP = CONSUMER_GROUPS.reduce((acc, g) => {
  g.canonicals.forEach((c) => { acc[c] = g.key; });
  return acc;
}, {});

// canonical 8종 → 5개 그룹 label 문자열 (내 문의 리스트 등에서 사용)
export const groupLabelForCanonical = (canonical) => {
  const gkey = CANONICAL_TO_GROUP[canonical] || 'other';
  const g = CONSUMER_GROUPS.find((x) => x.key === gkey);
  return g ? g.label : '기타 문의';
};

// 진입점(scope + defaultCategory) → 그룹 key 결정. 사용자가 다른 카테고리로 자유 변경 가능.
export const initialGroupKey = (defaultCategory) => {
  if (!defaultCategory) return 'other';
  return CANONICAL_TO_GROUP[defaultCategory] || 'other';
};
